export default "__VITE_ASSET__Zc11cIE$__"